import { useEffect, useRef, useState } from 'react'
import { Image as ImageIcon } from 'lucide-react'
import type { ResolvedImages } from '@/api/produktbilder'
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover'
import { ProductPhoto } from './ProductPhoto'

/** Verweildauer der Maus auf dem Symbol, bevor die Vorschau aufgeht (Nutzerwunsch 17.10.: ~2 s). */
export const BILD_VORSCHAU_VERZOEGERUNG_MS = 2000

/** Kleines Bildsymbol für Listen: das Foto lädt erst, wenn die Vorschau aufgeht.
 * Ohne Bild (oder solange die Auflösung lädt) bleibt der Platz leer, damit Namen bündig stehen. */
export function ProductPhotoHint({ images, alt }: { images?: ResolvedImages; alt: string }) {
  const [open, setOpen] = useState(false)
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null)
  useEffect(() => () => { if (timer.current) clearTimeout(timer.current) }, [])

  if (!images?.primary && !images?.components.length) return null

  function planen() {
    if (timer.current) clearTimeout(timer.current)
    timer.current = setTimeout(() => setOpen(true), BILD_VORSCHAU_VERZOEGERUNG_MS)
  }
  function schliessen() {
    if (timer.current) clearTimeout(timer.current)
    timer.current = null
    setOpen(false)
  }

  return <Popover open={open} onOpenChange={setOpen}>
    <PopoverTrigger asChild>
      <button type="button" aria-label={`Bild ansehen: ${alt}`}
        className="inline-flex size-5 items-center justify-center rounded text-muted transition-colors hover:text-primary focus-visible:outline-2 focus-visible:outline-primary data-[state=open]:text-primary"
        onMouseEnter={planen} onMouseLeave={schliessen} onBlur={schliessen}
        // nur Tastatur-Fokus planen: Maus-/Rueckgabe-Fokus wuerde die Vorschau sonst erneut oeffnen
        onFocus={(e) => { if (e.currentTarget.matches(':focus-visible')) planen() }}
        onClick={(e) => { e.stopPropagation(); if (timer.current) clearTimeout(timer.current); setOpen(true) }}>
        <ImageIcon className="size-3.5" aria-hidden />
      </button>
    </PopoverTrigger>
    <PopoverContent side="right" align="start" sideOffset={8} className="w-60 border-line-2 bg-panel p-2 shadow-lg"
      onOpenAutoFocus={(e) => e.preventDefault()} onCloseAutoFocus={(e) => e.preventDefault()}
      onClick={(e) => e.stopPropagation()}>
      <div className={images.primary ? 'h-52 w-full rounded bg-panel-2' : 'w-full'}>
        <ProductPhoto images={images} alt={alt} />
      </div>
    </PopoverContent>
  </Popover>
}
